import {
  Button,
  Card,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message, Modal,
  Popconfirm,
  Radio,
  Row,
  Table,
  Upload,
} from 'antd';
import { any } from 'prop-types';
import { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { map } from 'lodash/collection';
import { UploadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { nanoid } from 'nanoid';
import { addDecimalNum, moneyDelete } from '@/utils/utils';
import { uploadFileUrl } from '@/services/majorFinancing';
import FundingForm from '@/pages/agriculturalSubsidies/Application/components/FundingForm';
import { XMDD_ARG_PRO } from '@/utils/mappingDict';
import EquipmentExpandTable from '@/pages/agriculturalSubsidies/Application/components/EquipmentExpandTable';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';

const rowFormItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};
const currentYear = dayjs().year(); // 当前年份
function SubjectBasicInfo({
  formRef, dict, data, errorRowKeys,
}) {
  const [initiationYear, setInitiationYear] = useState(data?.initiationYear || dict.curYear);
  const { area } = useSelector((state) => state);
  const problemTbr = Form.useWatch('problemTbr', formRef);
  const [isModalOpen, setIsModalOpen] = useState(false); // 资金明细弹窗
  const [formValues, setFormValues] = useState({}); // 资金明细form值
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const dataSource = Form.useWatch('fundUtilizationVos', formRef) || [];

  // 根据明细计算总和
  const getTotal = (newData) => {
    formRef.setFieldsValue({
      totalInvestment: addDecimalNum(map(newData, (item) => item.investment)), // 项目计划总投资
      totalInvestmentCompleted: addDecimalNum(map(newData, (item) => item.investmentCompleted)), // 已完成总投资
      totalFinancialAidAmount: addDecimalNum(map(newData, (item) => item.financialAidAmount)), // 申报财政补助资金总额
      fundUtilizationVos: newData,
    });
    // setDataSource(newData);
  };

  const onOpen = (val) => {
    setIsModalOpen(true);
    const { subProjectCode, specialAgriculturalFundsEquips } = val;
    setFormValues({ ...val, projectName: subProjectCode, specialAgriculturalFundsEquips: isEmpty(specialAgriculturalFundsEquips) ? [{}] : specialAgriculturalFundsEquips });
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const onOk = (row) => {
    const investmentCompleted = addDecimalNum(row?.specialAgriculturalFundsEquips, 'equipmentInvestmentCompleted');
    const newRow = {
      ...row,
      subProjectCode: row?.projectName,
      investment: addDecimalNum([row?.provincialSubsidyFunds, row?.cityFunding, row?.selfFunding, row?.otherFunding]), // 项目计划投资
      investmentCompleted: investmentCompleted || 0, // 已完成投资
      financialAidAmount: moneyDelete(row?.provincialSubsidyFunds), // 申报财政补助金额
      specialAgriculturalFundsEquips:
      row?.specialAgriculturalFundsEquips?.map(
        ({ equipmentInvestmentCompleted, ...rest }) => rest,
      ),
    };
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.rowKey === item.rowKey);
    const newRowKey = nanoid();
    if (index !== -1) {
      const item = newData[index];
      newData.splice(index, 1, {
        ...item,
        ...newRow,
      });
    } else {
      newData.push({
        ...newRow,
        rowKey: newRowKey,
      });
    }
    setExpandedRowKeys([newRowKey]);
    setIsModalOpen(false);
    getTotal(newData);
  };

  const del = (id) => {
    const filteredList = dataSource.filter((item) => item.id !== id);
    const newList = filteredList.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
    getTotal(newList);
    message.success('删除成功');
  };

  const columns = [
    {
      title: '子项名称',
      dataIndex: 'projectName',
      width: 180,
      render: (text, record) => {
        const curStr = text || record?.subProjectCode;
        return (
          <DictionaryMatching value={curStr} dictionary={dict?.[XMDD_ARG_PRO]} />
        );
      },
    },
    {
      title: '建设内容',
      dataIndex: 'constructionContent',
    },
    {
      title: '项目计划投资(万元)',
      dataIndex: 'investment',
    },
    {
      title: '已完成投资(万元)',
      dataIndex: 'investmentCompleted',
    },
    {
      title: '申报财政补助资金(万元)',
      dataIndex: 'financialAidAmount',
    },
    {
      title: '操作',
      width: 100,
      render: (_, record) => (
        <>
          <a
            onClick={() => {
              onOpen(record); // 标识为编辑模式
            }}
            style={{ marginRight: 10 }}
          >
            编辑
          </a>
          <Popconfirm
            title="确定删除当前选项吗?"
            onConfirm={() => del(record.id)}
            okText="确定"
            cancelText="删除"
          >
            <a href="#">删除</a>
          </Popconfirm>
        </>
      ),
    },
  ];

  const props = {
    name: 'file',
    accept: '.jpg,.jpeg,.png',
    action: uploadFileUrl,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isLt2M) {
        message.error('请上传200M以下文件!');
      }
      return isLt2M;
    },
    onChange({ file, fileList }) {
      if (file.status === 'done') {
        message.success(`文件【${file.name}】上传成功`);
      } else if (file.status === 'error') {
        message.error('上传失败');
      }
      formRef.setFieldsValue({
        fileVos: isEmpty(fileList) ? undefined : fileList,
      });
    },
  };
  const yearList = [
    // {
    //   key: 'beforeLastYearRevenue', key2: 'beforeLastYearOutputValue', value: initiationYear - 2, required: true,
    // },
    {
      key: 'lastYearRevenue', key2: 'lastYearOutputValue', value: initiationYear - 1, required: true,
    },
    {
      key: 'currentYearRevenue', key2: 'currentYearOutputValue', value: initiationYear, required: true,
    },
    {
      key: 'nextYearRevenue', key2: 'nextYearOutputValue', value: initiationYear + 1, required: initiationYear + 1 <= currentYear,
    },
  ].map((item) => {
    // 新增模式 → 都可编辑
    const disabled = false;
    // 占时屏蔽过去时间不能编辑逻辑
    // if (data) {
    //   const currentDate = dayjs();
    //   const currentMonth = currentDate.month() + 1;
    //   const thresholdYear = currentMonth <= 6 ? currentYear - 1 : currentYear;
    //   if (item.value < currentYear) {
    //     // ✅ 编辑模式时判断年份
    //     disabled = item.value < thresholdYear;
    //   } else {
    //     disabled = false;
    //   }
    // }
    return { ...item, disabled };
  });

  const onDateChange = (date, str) => {
    setInitiationYear(Number(str));
  };

  useEffect(() => {
    if (dataSource?.length && expandedRowKeys.length === 0) {
      setExpandedRowKeys([dataSource[0].rowKey]);
    }
  }, [dataSource]);

  useEffect(() => {
    if (errorRowKeys.length > 0) {
      setExpandedRowKeys(errorRowKeys);
    }
  }, [errorRowKeys]);

  useEffect(() => {
    if (data?.initiationYear) {
      setInitiationYear(data?.initiationYear);
    } else {
      setInitiationYear(dict.curYear);
    }
  }, [data]);

  // eslint-disable-next-line no-nested-ternary
  const disabled = data?.id ? (!(data?.problemStatus === 0 && data?.solveDeptLevel === data?.agricultureDeptLevel)) : false;
  return (
    <>
      <Card title="项目信息" className="form-info__box">
        <Row>
          <Col span={12}>
            <Form.Item
              name="initiationYear"
              label="立项年度"
              rules={[
                {
                  required: true,
                  message: '请选择立项年度',
                },
              ]}
            >
              <DatePicker picker="year" allowClear={false} style={{ width: '100%' }} onChange={onDateChange} disabled={data?.id} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="projectName"
              label="项目名称"
              rules={[
                {
                  required: true,
                  message: '请输入项目名称',
                },
              ]}
            >
              <Input placeholder="请输入项目名称" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="projectArea"
              label="项目所属区域"
              rules={[
                {
                  required: true,
                  message: '请选择项目所属区域',
                },
              ]}
            >
              <Cascader
                options={area}
                placeholder="请选择项目所属区域"
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="fileVos"
              label="项目建设现场照片"
              valuePropName="fileList"
              rules={[
                {
                  required: true,
                  message: '请选择项目建设现场照片',
                },
              ]}
            >
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>上传照片</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{ sm: 12 }}
              name="newBuiltNum"
              label="新建农产品产地初加工和商品化处理设施"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber placeholder="新建农产品产地初加工和商品化处理设施" addonAfter="座" min={0} max={9999999999} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="totalInvestment"
              label="项目计划总投资"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber placeholder="项目计划总投资" addonAfter="万元" disabled style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="totalInvestmentCompleted"
              label="已完成总投资"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber placeholder="已完成总投资" addonAfter="万元" disabled style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="totalFinancialAidAmount"
              label="申报财政补助资金总金额"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber placeholder="申报财政补助资金总金额" addonAfter="万元" disabled style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="fundUtilizationVos"
              label="项目资金使用情况表"
              {...rowFormItemLayout}
              rules={[
                {
                  required: true,
                  validator: () => {
                    if (isEmpty(dataSource)) {
                      return Promise.reject(new Error('请追加项目资金使用情况表'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Button
                type="primary"
                onClick={() => onOpen({})}
              >
                追加
              </Button>
            </Form.Item>
          </Col>
          <Col span={24}>
             <Table
               size="small"
               rowKey="rowKey"
               columns={columns}
               dataSource={dataSource}
               pagination={false}
               expandable={{
                 expandedRowKeys,
                 onExpandedRowsChange: setExpandedRowKeys,
                 // eslint-disable-next-line react/no-unstable-nested-components
                 expandedRowRender: (record) => (
                  <EquipmentExpandTable
                    name={[`specialAgriculturalFundsEquips${record.rowKey}`]}
                    data={record.specialAgriculturalFundsEquips || []}
                    type={2}
                    formRef={formRef}
                  />
                 ),
                 rowExpandable: (record) => !isEmpty(record.specialAgriculturalFundsEquips),
               }}
             />
          </Col>
        </Row>
      </Card>
      <Card
        title={(
        <div>
          <span>企业信息</span>
          <span style={{ fontSize: 12, color: 'red', marginLeft: 10 }}>(注：当前年度的营业收入及产值为填报日为止的数据)</span>
        </div>
      )}
        className="form-info__box"
      >
        <Row>
          <Col span={12}>
            <Form.Item
              name="applicantName"
              label="企业名称"
              rules={[
                {
                  required: true,
                  message: '请输入企业名称',
                },
              ]}
            >
              <Input placeholder="请输入企业名称" disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="applicantNo"
              label="统一社会信用代码"
              rules={[
                {
                  required: true,
                  message: '统一社会信用代码',
                },
              ]}
            >
              <Input placeholder="统一社会信用代码" disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="area"
              label="注册地点/户籍所在地"
              rules={[
                {
                  required: true,
                  message: '请选择项注册地点/户籍所在地',
                },
              ]}
            >
              <Cascader
                options={area}
                placeholder="请选择项注册地点/户籍所在地"
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="problemTbr"
              label="是否有需要解决问题"
              rules={[
                {
                  required: true,
                  message: '请选择是否有需要解决问题',
                },
              ]}
            >
              <Radio.Group>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
          {
            yearList.map((item) => (
                <Row key={item.value} hidden={!item.required}>
                  <Col span={12}>
                    <Form.Item
                      name={item.key}
                      label={`企业${item.value}年营业收入`}
                      rules={[
                        {
                          required: item.required,
                          message: `请输入企业${item.value}年营业收入`,
                        },
                      ]}
                    >
                      <InputNumber placeholder={`请输入企业${item.value}年营业收入`} addonAfter="万元" style={{ width: '100%' }} disabled={item.disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={item.key2}
                      label={`企业${item.value}产值`}
                      rules={[
                        {
                          required: item.required,
                          message: `请输入企业${item.value}年产值`,
                        },
                      ]}
                    >
                      <InputNumber placeholder={`请输入企业${item.value}年产值`} addonAfter="万元" style={{ width: '100%' }} disabled={item.disabled} />
                    </Form.Item>
                  </Col>
                </Row>
            ))
          }
      </Card>
      {
        problemTbr === 1 && (
          <Card title="需要协助解决问题">
            <Row>
              <Col span={12}>
                <Form.Item
                  name="agricultureDeptLevel"
                  label="农业部门级别"
                  rules={[
                    {
                      required: true,
                      message: '请选择农业部门级别',
                    },
                  ]}
                >
                  <Radio.Group disabled={disabled}>
                    <Radio value={3}>县级</Radio>
                    <Radio value={2}>市级</Radio>
                    <Radio value={1}>省级</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="contactPhone"
                  label="企业联系方式"
                  rules={[
                    {
                      required: true,
                      message: '请输入企业联系方式',
                    },
                  ]}
                >
                  <Input disabled={disabled} placeholder="请输入企业联系方式" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  {...rowFormItemLayout}
                  name="problemDescription"
                  label="问题描述"
                  rules={[
                    {
                      required: true,
                      message: '请输入问题描述',
                    },
                  ]}
                >
                  <Input.TextArea disabled={disabled} placeholder="请输入问题描述" showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        )
      }
      <Modal
        title="资金使用情况"
        destroyOnClose
        footer={null}
        open={isModalOpen}
        width={1200}
        maskClosable={false}
        onCancel={onCancel}
      >
        <FundingForm
          onCancel={onCancel}
          onOk={onOk}
          data={formValues}
          dict={{ specialProjectName: dict[XMDD_ARG_PRO] }}
          type={2}
          parentForm={formRef}
        />
      </Modal>
    </>
  );
}

SubjectBasicInfo.propTypes = {
  formRef: any,
  data: any,
  dict: any,
  errorRowKeys: any,
};

export default SubjectBasicInfo;
